import { createCustomEnum } from "./customEnum";

const PendStatuses = createCustomEnum({
	open: {
		name: "open",
		value: 1,
		displayName: "Open",
	},
	response_submitted: {
		name: "response_submitted",
		value: 2,
		displayName: "Response Submitted",
	},
	reopen: {
		name: "reopen",
		value: 3,
		displayName: "Reopen",
	},
	closed: {
		name: "closed",
		value: 4,
		displayName: "Closed",
	},
});

export default PendStatuses;
